import { render, staticRenderFns } from "./BarOrderSubmit.vue?vue&type=template&id=5fc24430&scoped=true"
import script from "./BarOrderSubmit.vue?vue&type=script&lang=js"
export * from "./BarOrderSubmit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc24430",
  null
  
)

export default component.exports